"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const SunshineIcon_1 = __importDefault(require("../SunshineIcon"));
const Text_1 = __importDefault(require("../Text"));
const iconSizeMap = {
    md: 'icon-20',
    sm: 'icon-14',
};
const SunshineTag = ({ children, colorScheme = 'grey', icon, iconRight, noOfLines, size = 'md', ...props }) => {
    const styles = (0, react_1.useMultiStyleConfig)('SunshineTag', {
        colorScheme,
        size,
    });
    return (react_2.default.createElement(react_1.chakra.div, { __css: styles.container, ...props },
        icon ? (react_2.default.createElement(react_1.chakra.svg, { __css: styles.icon, as: SunshineIcon_1.default, name: icon, size: iconSizeMap[size] })) : null,
        react_2.default.createElement(react_1.chakra.p, { __css: styles.label, as: Text_1.default, noOfLines: noOfLines, size: size === 'md' ? 'sm' : 'xs' }, children),
        iconRight ? (react_2.default.createElement(react_1.chakra.svg, { __css: styles.iconRight, as: SunshineIcon_1.default, name: iconRight, size: iconSizeMap[size] })) : null));
};
exports.default = SunshineTag;
